import { CanvassingSessionListSort } from '../../graphql/__generated__/graphql';
import {
  DATE_RANGE_OPTIONS,
  type CanvassingSessionFilterState,
} from './canvassingSessionFilters';
import {
  getCanvassingSessionCaptureStatusFilterLabel,
  getCanvassingSessionListSortLabel,
  getCanvassingSessionProcessingStatusLabel,
} from './canvassingSessionLabels';

export const describeCanvassingSessionFilters = (
  filters: CanvassingSessionFilterState,
  resolveCanvasserLabel: (id: string) => string,
): string => {
  const dateRange = filters.dateRange === 'custom'
    ? `Custom (${filters.fromDate ?? 'not set'} through ${filters.throughDate ?? 'not set'})`
    : DATE_RANGE_OPTIONS.find(option => option.value === filters.dateRange)?.label ?? 'All time';
  const canvasser = filters.canvasserId === null ? 'All canvassers' : resolveCanvasserLabel(filters.canvasserId);
  const capture = filters.captureStatus === null
    ? 'All capture statuses'
    : getCanvassingSessionCaptureStatusFilterLabel(filters.captureStatus);
  const processing = filters.processingStatus === null
    ? 'All processing statuses'
    : getCanvassingSessionProcessingStatusLabel(filters.processingStatus);
  const sort = getCanvassingSessionListSortLabel(
    filters.sort === 'oldest' ? CanvassingSessionListSort.Oldest : CanvassingSessionListSort.Newest,
  );

  return `Date range: ${dateRange}; Canvasser: ${canvasser}; Capture status: ${capture}; Processing status: ${processing}; Sort: ${sort}.`;
};
